export default "__VITE_ASSET__DlhrX_4y__"